import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
        <div className="text-slate-500">Lade...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Redirect to user's home based on role
    const home = user.role === 'admin' || user.role === 'pm' ? '/admin'
      : user.role === 'customer' ? '/customer'
      : '/interpreter';
    return <Navigate to={home} replace />;
  }

  return children;
};

export default ProtectedRoute;
